module.exports = __webpack_public_path__ + "img/shop-icon-05.cad8ff71.png";